import {
  GET_RIDE_DETAILS,
} from "resources/actionTypes";

export function getRideDetails(data) {
  return {
    type: GET_RIDE_DETAILS.GET_RIDE_DETAILS_REQUESTED,
    payload: data,
  };
}

